
<!--=============== Banner start ==================-->
<div id="main-wrapper" style="text-align: left">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-left w-100 test">

                <!-- "> md" -->
                <img src="../../../assets/images/cloud-planning-images/banner-image.png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="banner-imag" />

                <!-- "<= md" -->
                <img src="../../../assets/images/banners/cloudplanmobile.jpg"
                    class="img img-responsive d-block d-md-none" width="100%" alt="" />

                <!-- <img src="../../../assets/images/banners/mitbannername.png"
                    alt="Banner-mit" class="img-responsive w-100 h-100"> -->
                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-8 col-md-4 col-sm-6 banner-section">
                            <div
                                class="align-items-center banner-content-title  global_title global_banner_title  title_banner_content" role="heading">

                                <span>Cloud Planning services</span>

                            </div>
                            <div class="global_sub_title global_banner_subtitle mt-3" role="heading">

                                <span>Enhance resilience and agility of your IT ecosystem on the cloud.</span>

                            </div>

                            <div class="col pt-lg-3 pt-4 mt-lg-3">
                                <a href="contact" class="global_button  text-left col  text-white white_button">
                                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                            alt="" /></div>
                                    TALK WITH EXPERTS
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- </div> -->
<!--==================== Banner end ===================-->





<!--====== Build applications Start ======-->
<div class="Helping-organizations">
    <div class="container">
        <div class="cybersecurity-about-box">
            <div class="row">
                <div class="col-lg-4">
                    <!-- <div class="conact-us-wrap-one managed-it"> -->
                    <div class="heading global_sub_title text-black">
                        <h5>Helping organizations align business goals with cloud technology.</h5>
                    </div>
                    <!-- </div> -->
                </div>
                <div class="col-lg-8 helping">
                    <div class="cybersecurity-about-text">
                        <div class="text global_section_content">
                            Establishing the role of cloud computing within your organization involves crucial steps in
                            planning
                            and designing your cloud environment. This includes determining what aspects will be managed
                            internally,
                            what will be outsourced, and setting clear service level expectations. It is crucial to
                            consider all
                            stakeholders involved in the cloud effort, including developers, operators, regulators, and
                            users of the
                            cloud services. This comprehensive approach helps to minimize surprises and challenges down
                            the road.
                        </div>

                        <div class="text global_section_content">
                            It's equally important to assess how your cloud will integrate with the existing data center
                            environment.
                            This involves evaluating shared management tools, security requirements, compliance
                            regulations, and determining
                            whether your cloud operates as an isolated system or part of a larger network that includes
                            public cloud resources.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--====== Build applications End ======-->




<!---------------------------Cloud Services Starts----------->

<div class="Cloud-Capabilities">
    <h3  class= "Cloud-Capabilities1" style="text-align:center"> Cloud Capabilities </h3>
    <div class="insight-subtitle global_sub_title1 casestudy-subtitle text-center my-3 ">
        Key steps in Cloud planning & Design
    </div>


    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-sm-6 col-md-4 boxes">
                <div class="box">
                    <h6 class="services">Cloud Service Design</h6>
                    <p>Identify and optimize cloud services, leveraging public resources, setting tiers and levels, and
                        creating a comprehensive "bill of materials" for organizational needs.</p>
                    <!-- <a href="cloud-managed-services"><button class="Learn-more btn btn-primary">Learn More</button></a> -->
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-4 boxes">
                <div class="box">
                    <h6 class="Operation_cloud">Defining Cloud Operations</h6>
                    <p>Optimize cloud performance through defining a reference architecture, addressing performance and
                        capacity planning, and ensuring operational compliance and security.</p>
                    <!-- <button class="Learn-more btn btn-primary">Learn More</button> -->
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-4 boxes">
                <div class="box">
                    <h6 class="Operation_cloud1">Cloud Business Planning</h6>
                    <p>Align your cloud with IT and business needs by assessing current and future demand, managing
                        relationships with service providers, implementing service costing and pricing strategies, and
                        ensuring compliance with relevant regulations.</p>
                    <!-- <button class="Learn-more btn btn-primary">Learn More</button> -->
                </div>
            </div>
        </div>
    </div>
</div>
<!-- </div> -->

<!---------------------------Cloud Services ends----------->



<!-- =============== platform section starts ================== -->
<div class="Cloud-Planning">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="global_section_header">The Cloud Planning Advantage</div>
                <div class="insights-subtitle global_sub_titles casestudy-subtitle my-3 my-lg-2">
                    <p>Strategic cloud planning can save millions, avert project failures, and manage risks. Before
                        diving
                        into technical details, thoughtful consideration of the approach is essential. Common challenges
                        include the demand for "more resources, faster," cost reduction, and controlling unauthorized
                        cloud use.
                        Clear project goals are pivotal, especially when industry-driven initiatives lack clarity.
                        Crafting a
                        well-defined cloud plan, achievable in weeks with the right team, streamlines technology
                        decisions,
                        establishes expectations, and signals a clear green light for implementation.
                    </p>
                </div>
            </div>

            <div class="col-md-6 col-sm-12">
                <img src="../../../assets/images/cloud-planning-images/cloud-planning-advantage.png" alt="cloud-planning-advantage" width="100%" />
            </div>
        </div>
    </div>
</div>

<div class="second-section">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <img src="../../../assets/images/cloud-planning-images/stakeholders.png" alt="stakeholders" width="100%" />
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="application_content_service global_section_header">Who Should Be Involved?</div>
                <div class="insights-subtitle global_sub_titles casestudy-subtitle my-3 my-lg-2">
                    <p>Engage stakeholders from various departments in IT and the broader business early in the
                        cloud planning process to accurately represent their goals and ensure ongoing support.
                        Key stakeholders include the cloud architect, capacity and performance team, network team,
                        storage team, and applications team. While it's essential to consider all stakeholders,
                        the initial cloud design team can start small and strategically expand over time to build
                        and develop the cloud offering.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="Experience-and-expertise">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="application_content_service global_section_header">Experience and expertise you can
                    trust.</div>
                <div class="insights-subtitle global_sub_titles casestudy-subtitle my-3 my-lg-2">
                    <p> Maganti IT Cloud Planning Services offers expert guidance and support to organizations looking
                        to realize
                        the maximum benefits of cloud technology. With over 20 years of experience, we help you navigate
                        the
                        complexities and uncertainties of cloud migration, ensuring a successful and risk-free
                        transition.
                        Whether you're planning a move to the cloud, looking to optimize your current infrastructure, or
                        have a unique plan in mind, our team is here to provide the confidence and expertise you need to
                        achieve your bottom-line goals.
                    </p>
                </div>
            </div>

            <div class="col-md-6 col-sm-12">
                <img src="../../../assets/images/cloud-planning-images/expertise.png" alt="expertise" width="100%" />
            </div>
        </div>
    </div>
</div>
<!-- =============== platform section ends ================== -->